var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8MaldivesCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.989,
    cy: 24,
    r: 20,
    fill: "#d50000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.989,
    cy: 24,
    r: 13.011,
    fill: "#388e3c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.466,24.099c0-3.454,2.581-6.311,5.957-6.846C26.831,17.093,26.212,17,25.57,17 c-3.92,0-7.099,3.178-7.099,7.099s3.178,7.099,7.099,7.099c0.642,0,1.261-0.093,1.853-0.253 C24.046,30.409,21.466,27.553,21.466,24.099z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8MaldivesCircular);
export default __webpack_public_path__ + "static/media/icons8-maldives-circular.efb8b383f6af713b6cf3d1ea4e14d2e4.svg";
export { ForwardRef as ReactComponent };